export default __webpack_public_path__ + "static/media/icon-external-link.9bd958b1.svg";